
export default class EmailVerification {

    constructor() {

        this.verification_timeout = null
        this.verify_email_timeout = null

        this.resendVerificationEmailButton = $('#verify-email-btn')


        this.events()
        this.onLoad()
    }

    events() {

        this.resendVerificationEmailButton.on('click', e => this.resendVerificationEmail(e))

        $('#verify-account-modal .verify-account-container .verify-account-input').focus(function() { $(this).select(); } );
        $('#verify-account-modal .verify-account-container .verify-account-input').on('paste', e => {
            e.preventDefault()
            let pasted_text = (event.clipboardData || window.clipboardData).getData('text')
            let reg = /^\d+$/;
            if(pasted_text.match(reg)) {
                pasted_text = pasted_text.split('')
                let element = $(e.currentTarget)
                pasted_text.forEach(nn => {
                    element.val(nn)
                    if(element.next) {
                        element.next().focus()
                    }
                    element = element.next()
                });
            }
        })
        $('#verify-account-modal .verify-account-container .verify-account-input').on('keydown', e => {
            // allow pasting
            if(!e.ctrlKey && e.keyCode != 86) {
                let reg = /^\d+$/;
                e.preventDefault()

                // backspace
                if(e.keyCode == 8) {
                    if($(e.currentTarget).val().length) {
                        $(e.currentTarget).val('')
                    } else {
                        $(e.currentTarget).prev().focus()
                    }
                    return false;
                }
                if(e.keyCode == 9) {
                    if(e.shiftKey) {
                        if($(e.currentTarget).prev().length) {
                            $(e.currentTarget).prev().focus()
                        } else {
                            $('#verify-account-modal .verify-account-container .verify-account-input').last().focus()
                        }
                        return false;
                    }
                    if($(e.currentTarget).next().length) {
                        $(e.currentTarget).next().focus()
                    } else {
                        $('#verify-account-modal .verify-account-container .verify-account-input').first().focus()
                    }
                    return false;
                }

                if(
                    !e.originalEvent.key.match(reg) &&
                    e.keyCode != 8 &&
                    e.keyCode != 9 &&
                    (e.shiftKey || e.keyCode == 9)
                    ) {
                    return false
                };

                if(e.originalEvent.key.match(reg) ) {
                    // if number is empty
                    if($(e.currentTarget).val().length == 0) {
                        $(e.currentTarget).val(e.originalEvent.key)
                        $(e.currentTarget).next().focus()
                    } else
                    // if number is not empty and selection is in the begining
                    if($(e.currentTarget).val().length == 1 && e.target.selectionStart == 0 && e.target.selectionEnd == 0){
                        $(e.currentTarget).next().val($(e.currentTarget).val())
                        $(e.currentTarget).val(e.originalEvent.key)
                        $(e.currentTarget).next().focus()
                    } else
                    // if number is not empty and selection is at the end
                    if($(e.currentTarget).val().length == 1 && e.target.selectionStart == 1 && e.target.selectionEnd == 1){
                        $(e.currentTarget).next().val(e.originalEvent.key)
                        $(e.currentTarget).next().focus()
                    } else
                    // if number is not empty and there is selection
                    if($(e.currentTarget).val().length == 1 && e.target.selectionStart == 0 && e.target.selectionEnd == 1){
                        $(e.currentTarget).val(e.originalEvent.key)
                        $(e.currentTarget).next().focus()
                    }
                    if(!$(e.currentTarget).next().length) {
                        $(e.currentTarget).blur()
                    }

                    let verification_code = "";
                    $('#verify-account-modal .verify-account-container .verify-account-input').each((index, el) => {
                        verification_code += el.value.toString()
                    })
                    if(verification_code.length == 6) {
                        this.verifyEmail(verification_code)
                    } else if(!$(e.currentTarget).next().length) $('#verify-account-modal .verify-account-container .verify-account-input').first().focus()

                }
            }
        })
        $('#resend-verification-code').on('click', e => this.resendVerificationEmail(e))
    }

    onLoad() {
    }

    resendVerificationEmail(e) {
        e.preventDefault()

        axios.post('/email/resend', {
            email: $('#email_field').val()
        }).then(res => {
            clearTimeout(this.verification_timeout)
            $('#verify-account-modal .verification-notification').removeClass('error')
            $('#verify-account-modal .verification-notification').text(res.data.message)
            $('#verify-account-modal .verification-notification').removeClass('d-none')
            this.verification_timeout = setTimeout(() => {
                $('#verify-account-modal .verification-notification').addClass('d-none')
            }, 7000);
        }).catch(err => {
            clearTimeout(this.verification_timeout)
            $('#verify-account-modal .verification-notification').addClass('error')
            $('#verify-account-modal .verification-notification').text(err.response.data.message)
            $('#verify-account-modal .verification-notification').removeClass('d-none')
            this.verification_timeout = setTimeout(() => {
                $('#verify-account-modal .verification-notification').addClass('d-none')
            }, 7000);
        })

        $('#verify-account-modal').modal()

    }

    verifyEmail(verification_code) {
        console.log('verifying email', verification_code)
        axios.post(`/email/verify/code`, {
            email: $('#email_field').val(),
            code: verification_code
        }).then(res => {
            $('#update-profile-btn').attr('disabled', true)
            clearTimeout(this.verify_email_timeout)
            $('#verify-account-modal .incorrect-verification').text('')
            $('#verify-account-modal').modal('hide')
            swal.fire({
                title : 'Your email has been verified.',
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: `OK`,
            }).then((result) =>{
                window.location.assign('/profile')
            });

        }).catch(err => {
            clearTimeout(this.verify_email_timeout)
            $('#verify-account-modal .incorrect-verification').text('⚠ Verification code is not correct.')
            this.verify_email_timeout = setTimeout(() => {
                $('#verify-account-modal .incorrect-verification').text('')
            }, 7000);
            console.err(err.response.data)
        })
    }

}
